export function invoicePaymentLink(invoice: { id: string; publicAccessToken?: string; allowThirdPartyPayments?: boolean; status?: string }, tenantId: string): string {
    if (!invoice.publicAccessToken || invoice.allowThirdPartyPayments === false || invoice.status === 'draft' || invoice.status === 'paid') return '';
    return `/api/public/invoices/${encodeURIComponent(invoice.publicAccessToken)}/pay?${new URLSearchParams({ tenantId, invoiceId: invoice.id })}`;
}
